import React from 'react';
import loadable from '@loadable/component';

const PetFilter = loadable(
  () =>
    import(
      /* webpackChunkName: "PetFilter.loadable" */ 'app/shared/modules/MobileSRP/Header/FilterModules/PetFilter/component'
    ),
);

class LoadablePetFilter extends React.Component {
  render() {
    return <PetFilter {...this.props} />;
  }
}

export default LoadablePetFilter;
